import { Route } from 'react-router-dom';
import { authPageViewportStyle } from '../components/auth/loginAuthTheme';
import { Login, ResetPassword, AcceptInvite, Unsubscribe, BillingDone } from '../pages/preAuthPages';
import { lazyWithRetry as lazy } from '../utils/ui/lazyWithRetry';

const EstimateRespond = lazy(() => import('../pages/EstimateRespond'));

/**
 * The signed-out / public routes, extracted from App.js (500-line cap, KAN-196).
 * Called as a function INSIDE <Routes> (React Router needs <Route> children, so
 * this returns a plain array of keyed <Route>s, never a wrapper component).
 */
export default function publicRoutes() {
  return [
    <Route key="login" path="/" element={<Login />} />,
    <Route key="reset" path="/reset-password" element={<div style={authPageViewportStyle()}><ResetPassword /></div>} />,
    <Route key="accept" path="/accept-invite" element={<div style={authPageViewportStyle()}><AcceptInvite /></div>} />,
    /* caseSensitive: same reason as /estimate below — the route and the BootGate/no-splash allowlist must match the exact same string. */
    <Route key="unsub" path="/unsubscribe" caseSensitive element={<Unsubscribe />} />,
    /* KAN-196: Stripe Checkout's return page. Public (an iOS PWA's in-app browser has no session). */
    <Route key="billingdone" path="/billing/done" element={<div style={authPageViewportStyle()}><BillingDone /></div>} />,
    /* RD-EST-RESP-001 — PUBLIC customer estimate approval/decline. Reached
        from an emailed `?token=` link, no session. Deliberately NOT wrapped
        in authPageViewportStyle(): that shell is height-pinned (it crops)
        and an estimate is a document that must GROW and scroll — same
        exemption /unsubscribe carries. Also exempt from BootGate (see
        utils/ui/bootGateExemptPaths.js).

        `caseSensitive` so the ROUTE and the boot-gate allowlist match the
        exact same string. Without it React Router matches `/Estimate`
        case-INSENSITIVELY and renders this page at a path that is boot-
        GATED and outside the `Referrer-Policy: no-referrer` rule in
        vercel.json — one page with two different security postures
        depending on capitalization. */
    <Route key="estimate" path="/estimate" caseSensitive element={<EstimateRespond />} />,
  ];
}
